// Shared styles for legal pages (privacy, cookies, terms, disclaimer).
const legalStyles = {
  page: { minHeight: '100vh', paddingTop: '3rem', paddingBottom: '4rem', backgroundColor: '#FAF9F6' },
  container: {
    maxWidth: '820px',
    margin: '0 auto',
    padding: '3rem 1.5rem',
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(2rem, 4vw, 3rem)',
    color: '#1A1918',
    marginBottom: '0.5rem',
  },
  lastUpdated: { color: '#8C8B88', fontSize: '0.875rem', marginBottom: '2rem' },
  article: { color: '#1A1918', lineHeight: 1.7 },
  h2: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.5rem',
    color: '#1A1918',
    marginTop: '2.5rem',
    marginBottom: '1rem',
  },
  h3: {
    fontFamily: "'Manrope', sans-serif",
    fontSize: '1.1rem',
    color: '#1A1918',
    marginTop: '1.5rem',
    marginBottom: '0.75rem',
    fontWeight: 600,
  },
  list: { paddingLeft: '1.5rem', marginBottom: '1rem', color: '#585755' },
  link: { color: '#C5A059', textDecoration: 'underline' },
  footnote: { color: '#585755', fontSize: '0.875rem', marginTop: '2.5rem', fontStyle: 'italic' },
  button: {
    backgroundColor: '#C5A059',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    fontSize: '0.875rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontWeight: 500,
    marginTop: '0.5rem',
  },
};

export default legalStyles;
